import { get } from 'lodash';

export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'Map',
      url: '/hawk_map',
      icon: 'icon-map',
      filter: userData => get(userData, 'account.hawk_user_token', null) !== null,
    },
    {
      name: 'Completion',
      url: '/completion',
      icon: 'fa fa-truck',
    },
    {
      name: 'Admin Area',
      url: '/admin',
      icon: 'fa fa-cog',
      userTypes: ['SYSTEM_ADMIN', 'ADMIN'],
      children: [
        {
          name: 'Companies',
          url: '/admin/companies',
          icon: 'fa fa-building',
          accessKey: 'MAIN.COMPANY.UPDATE',
        },
        {
          name: 'Users',
          url: '/admin/users',
          icon: 'fa fa-user',
          accessKey: 'MAIN.USER.UPDATE',
        },
        {
          name: 'Vehicles',
          url: '/admin/vehicles',
          icon: 'fa fa-truck',
          accessKey: 'MAIN.VEHICLE.UPDATE',
        },
        {
          name: 'Employees',
          url: '/admin/employees',
          icon: 'fa fa-male',
          accessKey: 'MAIN.EMPLOYEE.UPDATE',
        },
        {
          name: 'Prestart Checklist',
          url: '/admin/prestart_checklist',
          icon: 'fa fa-commenting',
          accessKey: 'MAIN.PRESTART_CHECKLIST.READ',
        },
        {
          name: 'Set Status Shipment',
          url: '/admin/set_status_shipment',
          icon: 'fa fa-edit',
        },
        {
          name: 'Vehicle Checklist',
          url: '/question_prestart',
          icon: 'fa fa-comments',
          accessKey: 'MAIN.PRESTART_CHECKLIST.READ',
        },
        {
          name: 'Vehicle Group',
          url: '/vehicle_group',
          icon: 'fa fa-car',
          accessKey: 'MAIN.VEHICLE_GROUP.READ',
        },
      ],
    },
    {
      name: 'Shipment MD',
      url: '/shipment_md',
      icon: 'fa fa-cube',
    },
    {
      name: 'Issue',
      url: '/issues',
      icon: 'fa fa-warning',
      accessKey: 'MAIN.ISSUE.READ',
    },
    {
      name: 'Order Routing',
      url: '/shipment_md/orders/routing',
      icon: 'fa fa-cubes',
      filter: (_, configs) => configs.isPrambananConfig,
    },
    {
      name: 'Order Status',
      url: '/shipment_md/orders/status',
      icon: 'fa fa-dot-circle-o',
      filter: (_, configs) => configs.isPrambananConfig,
    },
    {
      name: 'Order Schedule',
      url: '/shipment_md/orders/schedule',
      icon: 'fa fa-calendar',
      filter: (_, configs) => configs.isCOPPConfig,
    },
    {
      name: 'Order Delivery',
      url: '/shipment_md/orders/delivery',
      icon: 'fa fa-calendar',
      filter: (_, configs) => configs.isTRTConfig,
    },
    {
      name: 'Reports',
      url: '/report',
      icon: 'fa fa-file-excel-o',
      children: [
        {
          name: 'Generate',
          url: '/report',
          icon: 'fa fa-refresh',
        },
        {
          name: 'Files',
          url: '/report/files',
          icon: 'fa fa-file',
        },
      ],
    },
    {
      name: 'Hawk Report',
      url: '/hawk_report',
      icon: 'fa fa-file',
      filter: userData => get(userData, 'account.hawk_user_token', null) !== null,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/_nav.js